import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Blueprint from "@/pages/Blueprint";
import WhatsIncluded from "@/pages/WhatsIncluded";
import HandsOnTraining from "@/pages/HandsOnTraining";
import About from "@/pages/About";
import Apply from "@/pages/Apply";
import ApplicationReceived from "@/pages/ApplicationReceived";
import Enrollment from "@/pages/Enrollment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Refund from "@/pages/legal/Refund";
import Earnings from "@/pages/legal/Earnings";
import Funding from "@/pages/legal/Funding";
import NotFound from "@/pages/NotFound";

// Fire a Meta Pixel PageView on every SPA route change. The initial PageView
// is already fired by the base pixel snippet in public/index.html, so we
// deliberately skip the very first effect invocation (initial mount) to avoid
// a duplicate PageView on the initial page load. All subsequent route changes
// (SPA navigation) each fire exactly one PageView.
function MetaPixelRouteTracker() {
  const location = useLocation();
  const initialMountRef = useRef(true);
  useEffect(() => {
    if (initialMountRef.current) {
      initialMountRef.current = false;
      return;
    }
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    window.fbq("track", "PageView");
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MetaPixelRouteTracker />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/blueprint" element={<Blueprint />} />
            <Route path="/included" element={<WhatsIncluded />} />
            <Route path="/hands-on-training" element={<HandsOnTraining />} />
            <Route path="/about" element={<About />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/application-received" element={<ApplicationReceived />} />
            <Route path="/enrollment" element={<Enrollment />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<Refund />} />
            <Route path="/earnings-disclaimer" element={<Earnings />} />
            <Route path="/funding-disclaimer" element={<Funding />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
